import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import LinkedTitle from "../../utils/titles/LinkedTitle";
import Title from "../../utils/titles/Title";
import OrganizationsSearch from "./OrganizationsSearch";
import AdminOrganizationsForm from "./AdminOrganizationsForm";

class AdminOrganizationsEdit extends React.PureComponent {	
	render() {
		return (
			<React.Fragment>
				{this.props.role === 'manager' 
					? <Title>Organizations</Title>
					: <LinkedTitle link={{ href: "/admin/organizations/add", title: "Create" }}>
						Edit Organizations
					</LinkedTitle>
				}
				<Switch>
					<Route path={"/admin/organizations"} exact component={OrganizationsSearch} />
					<Route
						path={"/admin/organizations/edit"}
						exact
						component={OrganizationsSearch}
					/>
					<Route
						path={"/admin/organizations/edit/:id"}
						component={AdminOrganizationsForm}
					/>
				</Switch>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		role: state.user.admin.user.role
	};
};

export default connect(mapStateToProps)(AdminOrganizationsEdit);



// WEBPACK FOOTER //
// ./src/components/admin/organizations/AdminOrganizationsEdit.js